import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../common/api/queryKeys/queries';

export const useSupplierSettings = (supplierId: string) => {
    return useQuery(queries.suppliers.detail(supplierId)._ctx.settings);
};
